if (!customElements.get('product-card')) {

class ProductCard extends HTMLElement {
  connectedCallback() {
    this.cardInner = this.querySelector('.card__inner');
    if (!this.cardInner) return;

    this.onFocusIn = this.onFocusIn.bind(this);
    this.onFocusOut = this.onFocusOut.bind(this);
    this.onMediaClick = this.onMediaClick.bind(this);

    // Listen on the card itself, not on .card__inner: since the media lost its link
    // (a11y #310) the only focusable link is the title, which sits outside .card__inner.
    // Without this the hover video would never play for keyboard users (a11y #311).
    this.addEventListener('focusin', this.onFocusIn);
    this.addEventListener('focusout', this.onFocusOut);

    // The media is decorative and no longer wrapped in a link (a11y #310): the product
    // title is the single link. Mouse users keep the click target here.
    this.cardMedia = this.querySelector('.card__media');
    this.cardMedia?.addEventListener('click', this.onMediaClick);
  }

  disconnectedCallback() {
    if (!this.cardInner) return;
    this.removeEventListener('focusin', this.onFocusIn);
    this.removeEventListener('focusout', this.onFocusOut);
    this.cardMedia?.removeEventListener('click', this.onMediaClick);
  }

  onMediaClick(event) {
    if (event.target.closest('a, button, input, label, select, textarea, [role="button"]')) return;
    if (window.getSelection()?.toString()) return;

    const titleLink = this.querySelector('.card__heading a[href]');
    if (titleLink) titleLink.click();
  }

  onFocusIn() {
    this.activateLazyVideos();
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.deactivateLazyVideos();
      }
    });
  }

  activateLazyVideos() {
    this.cardInner
      .querySelectorAll('.media.media--hover-effect:not(.hidden) lazy-video')
      .forEach((lazyVideo) => lazyVideo.activate?.());
  }

  deactivateLazyVideos() {
    this.cardInner
      .querySelectorAll('.media.media--hover-effect lazy-video')
      .forEach((lazyVideo) => lazyVideo.deactivate?.());
  }
}

customElements.define('product-card', ProductCard);

} // end if
